import { Directive, ElementRef, inject, Input, OnChanges, Renderer2 } from '@angular/core';
import type { SimpleChanges } from '@angular/core';

/** Wraps the first case-insensitive match of the bound text in a bold element. */
@Directive({
  selector: '[appHighlightText]',
  standalone: true
})
export class HighlightTextDirective implements OnChanges {
  @Input('appHighlightText') text: string;
  private readonly el = inject(ElementRef);

  constructor(
    // private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) { }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['text']) {
      this.updateText(this.text);
    }
  }

  private updateText(text: string) {
    const element = this.el.nativeElement as HTMLElement;
    const content = element.textContent ?? '';
    const matchIndex = text ? content.toLocaleLowerCase().indexOf(text.toLocaleLowerCase()) : -1;

    this.renderer.setProperty(element, 'textContent', '');
    if (matchIndex < 0) {
      this.renderer.appendChild(element, this.renderer.createText(content));
      return;
    }

    const highlight = this.renderer.createElement('b');
    this.renderer.appendChild(highlight, this.renderer.createText(content.slice(matchIndex, matchIndex + text.length)));
    this.renderer.appendChild(element, this.renderer.createText(content.slice(0, matchIndex)));
    this.renderer.appendChild(element, highlight);
    this.renderer.appendChild(element, this.renderer.createText(content.slice(matchIndex + text.length)));
  }
}